/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Demo_Unavailable_TitleInputs */



/**
* | output |
* | --- |
* | "Not available in this demo environment" |
*
* @param {Demo_Unavailable_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const demo_unavailable_title = /** @type {((inputs?: Demo_Unavailable_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Demo_Unavailable_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Niet beschikbaar in deze demo-omgeving")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Non disponible dans cet environnement de démo")
	return /** @type {LocalizedString} */ ("Not available in this demo environment")
});